<template>
    <div class="page newpage">
        <el-tabs v-model="tabType" type="card" @tab-click="handleClick">
			<el-tab-pane v-for="item in tabArr" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
		</el-tabs>
        <div class="_flex" v-if="tabType==1">
            <el-date-picker v-model="lsearch.created_time" type="daterange" clearable value-format="yyyy-MM-dd" range-separator="至" start-placeholder="创建开始时间" end-placeholder="创建结束时间" size="small" placeholder="创建时间范围" style="margin-left: 10px;" />
			<el-input v-model="lsearch.content" size="small" clearable placeholder="文档内容" style="width: 200px;margin-left: 10px;"/>
			<el-input v-model="lsearch.admin_phone" size="small" clearable placeholder="编辑人账号" style="width: 200px;margin-left: 10px;"/>
            <el-button size="mini" @click="getSmslogLists(1)" style="margin-left: 10px;">筛选</el-button>
            <el-button size="mini" type="success" v-permit="'/admin/article/smslogAdd'" @click="addLog">批量发送</el-button>
		</div>
		<div class="mt_10" v-if="tabType==1">
			<el-table :data="logArr" stripe :header-cell-style="{ background:'#f5f5f5'}" v-loading="loading">
			    <el-table-column prop="id" label="序号" width="100"></el-table-column>
			    <el-table-column prop="title" label="标题" min-width="150"></el-table-column>
                <el-table-column prop="content" label="内容" min-width="400">
                    <template slot-scope="scope">
                        <div style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;">{{scope.row.content}}</div>
                    </template>
                </el-table-column>
			    <el-table-column prop="created_time" label="创建时间" width="200"></el-table-column>
                <el-table-column prop="total" label="条数" width="100">
                    <template v-slot="{row}">
                        {{row.success}} / {{row.total}}
                    </template>
                </el-table-column>
                <el-table-column prop="state_text" label="状态" width="100"></el-table-column>
			    <el-table-column prop="created_by" label="编辑人" width="180">
                    <template v-slot="{row}">
                        {{row.admin ? row.admin.nick_name : ''}} {{row.admin && row.admin.phone ? row.admin.phone.slice(-4) : ''}}
                    </template>
                </el-table-column>
			    <el-table-column label="操作" width="180px">
					<template v-slot="{row}">
                        <el-button type="primary" size="mini" v-permit="'/admin/article/smslogEdit'" @click="editLog(row)">编辑</el-button>
                        <el-button type="danger" size="mini" v-permit="'/admin/article/smslogDel'" @click="delLog(row)">删除</el-button>
                    </template>
			    </el-table-column>
			  </el-table>
			  <div class="mt_30 t_r">
				  <el-pagination background
                        @size-change="changeLogLimit"
					  :current-page="lsearch.page"
                        @current-change="changeLogPage"
					  :page-size="lsearch.limit"
					  layout="total, sizes, prev, pager, next, jumper"
					  :total="lsearch.total"></el-pagination>
			  </div>
		</div>
        <div class="_flex" v-if="tabType==2">
			<el-date-picker v-model="tsearch.created_time" type="daterange" clearable value-format="yyyy-MM-dd" range-separator="至" start-placeholder="创建开始时间" end-placeholder="创建结束时间" size="small" placeholder="创建时间范围" style="margin-left: 10px;" />
			<el-input v-model="tsearch.content" size="small" clearable placeholder="文档内容" style="width: 200px;margin-left: 10px;"/>
			<el-input v-model="tsearch.admin_phone" size="small" clearable placeholder="编辑人账号" style="width: 200px;margin-left: 10px;"/>
            <el-button size="mini" @click="getTemplateLists(1)" style="margin-left: 10px;">筛选</el-button>
            <el-button size="mini" type="success" v-permit="'/admin/article/add'" @click="addTemplate">添加</el-button>
		</div>
		<div class="mt_20" v-if="tabType==2">
			<el-table :data="templateArr" stripe :header-cell-style="{ background:'#f5f5f5'}" v-loading="loading">
			    <el-table-column prop="id" label="序号"></el-table-column>
			    <el-table-column prop="cate_name" label="类型" ></el-table-column>
			    <el-table-column prop="title" label="标题" ></el-table-column>
			    <el-table-column prop="created_time" label="上传" ></el-table-column>
			    <el-table-column prop="created_by" label="编辑人" >
                    <template v-slot="{row}">
                        {{row.admin ? row.admin.nick_name : ''}} {{row.admin && row.admin.phone ? row.admin.phone.slice(-4) : ''}}
                    </template>
                </el-table-column>
			    <el-table-column prop="state_text" label="审核状态" ></el-table-column>
			    <el-table-column prop="views" label="浏览次数" ></el-table-column>
			    <el-table-column label="操作" width="180px">
					<template v-slot="{row}">
                        <el-button type="primary" size="mini" v-permit="'/admin/article/edit'" @click="edit(row)">编辑</el-button>
                        <el-button type="danger"  size="mini" v-permit="'/admin/article/del'" @click="del(row.id)">删除</el-button>
					</template>
			    </el-table-column>
			  </el-table>
			  <div class="mt_30 t_r">
                    <el-pagination background :current-page="tsearch.page" :page-size="tsearch.limit" :total="tsearch.total"
                        @size-change="changeTemplatePage" @current-change="changeTemplatelimit"
                        layout="total, sizes, prev, pager, next, jumper"
                    ></el-pagination>
			  </div>
		</div>
		<div class="w_50" v-if="tabType==3">
			<el-form label-position="right" label-width="200px" :model="setForm" class="pr_20">
			  <el-form-item label="短信充值：">
			    请在短信宝平台注册账号并充值（<a href="http://www.smsbao.com/reg?r=11661" target="_blank">http://www.smsbao.com/reg?r=11661</a>）
			  </el-form-item>
			  <el-form-item label="短信宝平台账号：">
			    <el-input v-model="setForm.smbao_account"></el-input>
			  </el-form-item>
			  <el-form-item label="短信宝账号密码：">
			    <el-input v-model="setForm.smbao_pass"></el-input>
			  </el-form-item>
			  <el-form-item label="剩余短信数：">
			    <div class="_flex">
					<el-input v-model="setForm.smbao_left" class="w200"></el-input>
                    <el-button type="success" :loading="lefting" @click="hanleSmbaoLeft" style="margin-left: 10px;">{{lefting ? '正在获取短信数量' : '获取短信数量'}}</el-button>
				</div>
			  </el-form-item>
			  <div class="ml_200 mt_50">
                <el-button type="primary" @click="submitSet">保存</el-button>
			  </div>
			</el-form>
		</div>
		
		<el-dialog :title="templateForm.id > 0 ? '编辑模板' : '新增模板'" :visible="show" width="600px" center @close="show=false">
		  <el-form label-position="right" label-width="80px" :model="templateForm" class="pr_20">
		    <el-form-item label="标题：">
		      <el-input v-model="templateForm.title"></el-input>
		    </el-form-item>
		    <el-form-item label="排序：">
		      <el-input v-model="templateForm.sort"></el-input>
		    </el-form-item>
			<el-form-item label="分类：">
		      <el-select v-model="templateForm.cate_id" class="w_100" placeholder="请选择" @visible-change="getArticleCateLists">
		          <el-option v-for="(item,index) in cateArr" :key="index" :label="item.name" :value="item.id"> </el-option>
		        </el-select>
		    </el-form-item>
		    <el-form-item label="内容：">
				<el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="templateForm.content"></el-input>
		    </el-form-item>
		  </el-form>
            <span slot="footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="submitTemplate">确 定</el-button>
            </span>
		</el-dialog>
		
        <Smssend :visible="smsVisible" :userArr="selectedUsers" :formDate="smslogDetail" @close="smsVisible = false" />
    </div>
</template>
<script>
import Smssend from "@/components/crm/Smssend.vue"
import { articleLists, articleAdd, articleEdit, articleDetail, articleDel, articleCateLists, articleCateAdd, articleCateEdit, articleCateDel, smbao, getSmbaoLeft, smslogLists, smslogAdd, smslogEdit, smslogDel, smsSend, smslogDetail, userLists } from "@/request/apis.js"
import store from "@/store/index.js"
export default{
    components: { Smssend },
    data(){
        return {
            loading: false,
            tabArr: [],
			tabType : '1',
			name:'',
            list : [{id:1,name:'张三是'}],
			show : false,
			represShow : false,
			formData : {
				name : ''
			},
            setForm: { smbao_account: '', smbao_pass: '', smbao_left: '', },
            lefting: false,

            templateArr: [],
            tsearch: { 
                page: 1, 
                pageSize: 10, 
                total: 0, 
                keyword: '',
                created_time: [],
                content: '',
                admin_phone: '',
             },
            cateArr: [],
            templateFormInt: {},
            templateForm: { id: 0, title: '', sort: '', cate_id: '', content: '', type: 3 },
            lsearch: { 
                page: 1, 
                pageSize: 10, 
                total: 0, 
                created_time: [],
                content: '',
                admin_phone: '',
            },
            logArr: [],
            logFormInit: {},
            logForm: {
                id: '',
                use_template: '1',
                template_id: '',
                content: '',
                tmp_ids: [],
                users: [],
                consumer_ids: [],
            },
            loading: false,
            userArr: [],
            smsVisible: false,
            selectedUsers: [],
            smslogDetail: {},
        }
    },
	mounted() {
        this.logFormInit = {...this.logForm};
        this.templateFormInit = {...this.templateForm};
        this.templateFormInt = {...this.templateForm};

        let auth1 = this.checkAuth('/admin/article/smslogLists');
        let auth2 = this.checkAuth('/admin/article/lists');
        let auth3 = this.checkAuth('/admin/setting/smbao');

        if(auth1){
            this.tabArr.push({label: '推送短信', name: '1'});
        }
        if(auth2){
            this.tabArr.push({label: '短信模板', name: '2'});
        }
        if(auth3){
            this.tabArr.push({label: '短信配置', name: '3'});
        }

        if (auth1){
            this.tabType = '1';
            this.getSmslogLists(1);
        }else if(auth2){
            this.tabType = '2';
            this.getTemplateLists(1);
        }else if(auth3){
            this.tabType = '3';
            this.getSmbao();
        }
	},
	methods:{
        handleClick(){
            console.log('handleClick')
            if(this.tabType == 1){
                this.getSmslogLists(1);
            }else if(this.tabType == 2){
                this.getTemplateLists(1);
            }else if(this.tabType == 3){
                this.getSmbao();
            }
        },
        async getSmslogLists(page){
            if(page){
                this.lsearch.page = page;
            }
            this.loading = true;
            let res = await smslogLists(this.lsearch);
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.logArr = res.data;
            this.lsearch.total = res.count;
        },
        changeLogLimit(limit){
            this.lsearch.limit = limit;
            this.getSmslogLists(1);
        },
        changeLogPage(page){
            this.getSmslogLists(page);
        },
        addLog() {
            this.smslogDetail = {};
            this.selectedUsers = [];
            this.smsVisible = true;
        },
        async editLog(row){
            let res = await smslogDetail({id: row.id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.smslogDetail = res.data;
            this.selectedUsers = res.data.users || [];
            this.smsVisible = true;
        },
        async delLog(row){
            this.$confirm('数据删除之后无法恢复, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await smslogDel({id: row.id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.getSmslogLists();
            }).catch(() => { });
        },
        async changeTemplate(){
            console.log('changeTemplate', this.logForm.template_id, this.templateArr)
            if(this.logForm.template_id){
                this.templateArr.forEach(async template => {
                    if(template.id == this.logForm.template_id){
                        let res = await articleDetail({id: template.id});
                        if (res.code != 0) {
                            return this.$message.error(res.msg);
                        }
                        this.logForm.content = res.data.content;
                    }
                });
            }
        },
        async getTemplateLists(page){
            if(page){
                this.tsearch.page = page;
            }
            this.loading = true;
            let res = await articleLists({type: 3, ...this.tsearch});
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.templateArr = res.data;
            this.tsearch.total = res.count;
        },
        changeTemplatelimit(limit){
            this.tsearch.limit = limit;
            this.getTemplateLists(1)
        },
        changeTemplatePage(page){
            this.getTemplateLists(page);
        },
        async getArticleCateLists(query) {
            if(!query){
                return;
            }
            let res = await articleCateLists({type: 3});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.cateArr = res.data;
            console.log('cateArr', this.cateArr)
        },
        addTemplate(){
            this.templateForm = {...this.templateFormInt};
            console.log('addTemplate', this.templateForm)
            this.show = true;
        },
        async edit(row){
            let res = await articleDetail({id: row.id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.getArticleCateLists(true);
            this.templateForm = res.data;
            this.show = true;
        },
        async submitTemplate(){
            let res;
            console.log('submitTemplate', this.templateForm)
            if(this.templateForm.id){
                res = await articleEdit(this.templateForm);
            }else{
                res = await articleAdd(this.templateForm);
            }
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg || '操作成功');
            this.show = false;
            this.getTemplateLists(1);
        },
        del(id){
            this.$confirm('数据删除不可恢复，请谨慎操作！, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var res = await articleDel({id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.getarticleLists();
            }).catch(() => { });
        },
        async getSmbao(){
            let res = await smbao('get');
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            if(res.data.smbao_account){
                this.setForm.smbao_account = res.data.smbao_account;
            }
            if(res.data.smbao_pass){
                this.setForm.smbao_pass = res.data.smbao_pass;
            }
        },
        async submitSet(){
            let res = await smbao('post', this.setForm);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
        },
        async hanleSmbaoLeft(){
            if(!this.setForm.smbao_account || !this.setForm.smbao_pass){
                return this.$message.error('请先设置短信宝账号和密码');
            }
            this.lefting = true;
            let res = await getSmbaoLeft(this.setForm);
            this.lefting = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.setForm.smbao_left = res.data;
        }
	}
}
</script>

<style  scoped>
</style> 